<script>;
;
import VegaEmbed from "./VegaEmbed.svelte";
export let view;
export let spec;
export let options = {};
export let data = {};
export let signalListeners = {};
const mode = "vega";
$: vegaOptions = Object.assign(Object.assign({}, options), { mode: mode });
</script>

<VegaEmbed
  {spec}
  {data}
  {signalListeners}
  options={vegaOptions}
  bind:view
  on:onNewView
  on:onError
/>
